import React from 'react';
import {useSelector} from 'react-redux';
import Spinner from '../../../../common/components/ui/Spinner';
import {useListUnreadMessagesContext} from '../ListUnreadMessagesContext';
import {RootState} from '../../../../store/configureStore';
import styles from './UnreadMessage.module.scss';

const UnreadMessage = () => {
  const {currentMessage} = useListUnreadMessagesContext();
  const locale = useSelector((state: RootState) => state.i18n.locale);

  return (
    <div className={styles.unreadMessageContainer}>
      {(currentMessage)
        ? (
          <>
            <div className={styles.title}>{currentMessage.content[locale].title}</div>
            <div className={styles.message}>{currentMessage.content[locale].text}</div>
          </>
        )
        : <Spinner/>
      }
    </div>
  );
};

export default UnreadMessage;
